import type { IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import { editorWritten, editorTabs, keyToggles } from './formRules';
import { explicitWidthsOf } from './formWidths';
import type { FormSourceKind } from './FormSourceKind';
import type { IProtoForm } from './IProtoForm';
import { isSeededLayout, protoFormOf } from './protoForm';
import { standardFormOf } from './standardForm';

/** Чи дві моделі дають ту саму форму: ключовий рядок, теги й опис, вкладки, групи (англійські назви, «Увесь рядок», поля), приховані поля. */
export function sameForm(a: IProtoForm, b: IProtoForm): boolean {
  const groups = (f: IProtoForm) => JSON.stringify(f.groups.map((g) => [g.title.en ?? '', g.full, g.keys]));
  return keyToggles.every((k) => a.key[k] === b.key[k]) && a.showTags === b.showTags && a.showDesc === b.showDesc
    && editorTabs.every((t) => a.tabs[t] === b.tabs[t]) && groups(a) === groups(b) && [...a.hidden].sort().join() === [...b.hidden].sort().join();
}

/**
 * Звідки форма типу записів у просторі (прототип v4 laySrc): «ws» — форма робочого простору (збережена редактором і відмінна від
 * стандартного макета або з явними ширинами полів; засіяний прототипом макет реєстрів і фінансів), «std» — стандартний макет.
 * `published` — опубліковане визначення типу (типові вкладки стандартного макета). Чиста функція.
 */
export function formSourceOf(rt: IRecordTypeDefinition, patch: IRecordTypeOverride, published?: IRecordTypeDefinition): FormSourceKind {
  if (!editorWritten(patch)) return isSeededLayout(rt) ? 'ws' : 'std';
  const same = sameForm(protoFormOf(rt, patch), standardFormOf(rt, (published ?? rt).form.tabs));
  return same && !Object.keys(explicitWidthsOf(patch)).length ? 'std' : 'ws';
}
